export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

let faviconVisibilityHandler = null;

export const initFaviconSwitcher = () => {
  // Remove previous listener to prevent accumulation
  if (faviconVisibilityHandler) {
    document.removeEventListener('visibilitychange', faviconVisibilityHandler);
  }

  const favicons = document.querySelectorAll('.favicon');

  faviconVisibilityHandler = () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = `/favicon-${favicon.sizes[[0]]}.png`;
        favicon.href = oldFileName;
      });
    }
  };

  document.addEventListener('visibilitychange', faviconVisibilityHandler);
};
